<template>
  <aside class="main-sidebar">
    <section class="sidebar" data-widget="tree">
      <!-- Sidebar user panel (optional) -->
      <div class="user-panel">
        <div class="pull-left image">

          <img :src="getMainUser.avatar" class="img-circle" alt="User Image">
        </div>
        <div class="pull-left info">
          <p> {{ this.getMainUser.name }}</p>
          <!-- Status -->
          <a href="#"><i class="fa fa-circle text-success"></i> Online</a>
        </div>
      </div>

      <search-general>
      </search-general>

      <ul class="sidebar-menu">
        <li class="header">MENU</li>
        <!-- Optionally, you can add icons to the links -->
        <li :class="{'active':isRouteName('Dashboard')}">
          <router-link to="/">
            <i class="fa fa-home"></i>
            <span>Accueil</span>
          </router-link>
        </li>

        <li :class="{'active':isRouteName('AddMembre')}">
          <router-link to="/add-member">
            <i class="fa fa-plus"></i>
            <span>Ajouter membre</span>
          </router-link>
        </li>

        <li :class="{'active':isRouteName('AddClub')}">
          <router-link to="/add-club">
            <i class="fa fa-plus"></i>
            <span>Ajouter club</span>
          </router-link>
        </li>

        <li :class="{'active':isRouteName('Avertissements')}">
          <router-link to="/avertissements">
            <i class="fa fa-warning"></i>
            <span>Avertissements</span>
          </router-link>
        </li>

        <li :class="{'active':isRouteName('Labelisation')}">
          <router-link to="/labelisation">
            <i class="fa fa-tags"></i>
            <span>Labelisation</span>
          </router-link>
        </li>

        <li :class="{'active':isRouteName('Recap')}">
          <router-link :to="{name: 'Recap', params: { recap_id: 0 }}">
            <i class="fa fa-th-list"></i>
            <span>Récapitulatifs</span>
          </router-link>
        </li>
        <li :class="{'active':isRouteName('Liste_commandes_myabft')}">
          <router-link :to="{name: 'Liste_commandes_myabft', params: { order_id: 0 }}">
            <i class="fa fa-th-list"></i>
            <span>Bons de commande</span>
          </router-link>
        </li>
        <li :class="{'active':isRouteName('Formation')}">
          <router-link :to="{ name: 'Formation', params: { formation_id: 0 }}">
            <i class="fa fa-th-list"></i>
            <span>Formations</span>
          </router-link>
        </li>
        <li :class="{'active':isRouteName('Competition')}">
          <router-link :to="{ name: 'Competition', params: { competition_id: 0 }}">
            <i class="fa fa-th-list"></i>
            <span>Compétitions</span>
          </router-link>
        </li>

        <li :class="{'active':isRouteName('Verifications_competiteurs')}">
          <router-link :to="{ name: 'Verifications_competiteurs'}">
            <i class="fa fa-th-list"></i>
            <span>Vérifications des compétiteurs</span>
          </router-link>
        </li>
        <li :class="{'active':isRouteName('Statistiques_generales')}">
          <router-link :to="{ name: 'Statistiques_generales'}">
            <i class="fa fa-th-list"></i>
            <span>Statistiques et fichiers</span>
          </router-link>
        </li>

        <li :class="{'active':isRouteName('Ranking')}">
          <router-link :to="{ name: 'Ranking'}">
            <i class="fa fa-dashboard"></i>
            <span>Ranking</span>
          </router-link>
        </li>


        <li class="treeview " v-if="getProcessEnv.NODE_ENV=='development'">
          <a href="">
            <i class="fa fa-th-list"></i>
            <span>Membres</span>
            <i class="fa fa-angle-left pull-right"></i>
          </a>
          <ul class="treeview-menu">
            <li class="/">
              <router-link :to="{ name: 'Member', params: { member_id: 42 }}">
                <i class="fa fa-home"></i>
                <span>Membre Pascal</span>
              </router-link>

            </li>
            <li class="/">
              <router-link :to="{ name: 'Member', params: { member_id: 81 }}">
                <i class="fa fa-home"></i>
                <span>Membre Eric</span>
              </router-link>
            </li>
            <li class="/">
              <router-link :to="{ name: 'Member', params: { member_id: 17724 }}">
                <i class="fa fa-home"></i>
                <span>Membre Licencié</span>
              </router-link>
            </li>
          </ul>
        </li>

        <li class="treeview " v-if="getProcessEnv.NODE_ENV=='development'">
          <a href="">
            <i class="fa fa-th-list"></i>
            <span>Clubs</span>
            <i class="fa fa-angle-left pull-right"></i>
          </a>
          <ul class="treeview-menu">
            <li class="/">
              <router-link :to="{ name: 'Club', params: { club_id: 145 }}">
                <i class="fa fa-home"></i>
                <span>Club 145</span>
              </router-link>
            </li>
            <li class="/">
              <router-link :to="{ name: 'Club', params: { club_id: 165 }}">
                <i class="fa fa-home"></i>
                <span>Club 165</span>
              </router-link>
            </li>
          </ul>
        </li>

        <li class="treeview " v-if="getProcessEnv.NODE_ENV=='development'">
          <a href="">
            <i class="fa fa-th-list"></i>
            <span>Comptabilité</span>
            <i class="fa fa-angle-left pull-right"></i>
          </a>
          <ul class="treeview-menu">
            <li>
              <router-link :to="{ name: 'Operations', params: { club_id: 165 }}">
                <span>Liste des opérations sur le compte</span>
              </router-link>
            </li>
            <li class="">
              <a href="">Liste des factures</a>
            </li>
            <li class="">
              <router-link :to="{ name: 'Operations', params: { club_id: 165 }}">
                <span>Mettre à jour les opérations</span>
              </router-link>
              <!--<a href="">Mettre à jour les opérations</a>-->
            </li>
          </ul>
        </li>

        <li class="treeview">
          <a href="">
            <i class="fa fa-feed"></i>
            <span>Outils</span>
            <i class="fa fa-angle-left pull-right"></i>
          </a>
          <ul class="treeview-menu" >
            <li :class="{'active':isRouteName('Generation_courrier')}">
              <router-link :to="{ name: 'Generation_courrier'}">
                <span>Génération courrier</span>
              </router-link>
            </li>
            <li :class="{'active':isRouteName('Generation_etiquette')}">
              <router-link :to="{ name: 'Generation_etiquette'}">
                <span>Génération étiquettes</span>
              </router-link>
            </li>
            <li :class="{'active':isRouteName('Generation_carte_coach')}">
              <router-link :to="{ name: 'Generation_carte_coach'}">
                <span>Génération de carte coach</span>
              </router-link>
            </li>
            <li :class="{'active':isRouteName('Generation_diplome')}">
              <router-link :to="{ name: 'Generation_diplome'}">
                <span>Génération de diplome</span>
              </router-link>
            </li>
            <!--<li class="">-->
            <!--<router-link :to="{ name: 'Generation_facture'}">-->
            <!--<span>Génération facture</span>-->
            <!--</router-link>-->
            <!--</li>-->
            <li :class="{'active':isRouteName('RechercheAvancee')}">
              <router-link :to="{ name: 'RechercheAvancee'}">
                <span>Recherche avancée</span>
              </router-link>
            </li>

            <li :class="{'active':isRouteName('EnvoiSMS')}">
              <router-link :to="{ name: 'EnvoiSMS'}">
                <span>Envoi de SMS</span>
              </router-link>
            </li>
            <li :class="{'active':isRouteName('InfosGenerales')}">
              <router-link :to="{ name: 'InfosGenerales'}">
                <span>Informations générales</span>
              </router-link>
            </li>
          </ul>
        </li>

<!--        <li>-->
<!--          <a class="btn" @click="test()">Test router</a>-->
<!--        </li>-->
      </ul>
    </section>
  </aside>
</template>

<script type="text/babel">
    import Auth from '@/auth'
    import searchGeneral from '../Communs/searchGeneral'
    import {mapGetters, mapActions} from 'vuex'

    export default {
        data() {
            return {
                // auth: this.$store.state.auth,
            }
        },
        methods: {
            isRouteName:function(name) {
                return this.$route.name==name
            },
            // test: function () {
            //     console.log(this.$route);
            // }
        },
        components: {
            searchGeneral
        },
        computed: {
            ...mapGetters({
                getMainUser: 'getMainUser',
                getRoute: 'getRoute',
                getProcessEnv: 'getProcessEnv',
            })
        },
    };
</script>



// WEBPACK FOOTER //
// src/components/Communs/sidebar.vue